import React, { useRef } from 'react'
import { Navbar } from '../layouts/Navbar'
import { HeroSection } from '../components/HeroSection'
import { Hero2 } from '../components/shared/Hero2'
import { Figures } from '../components/shared/Figures'
import { Partners } from '../components/shared/Partners'
import { Supporters } from '../components/shared/Supporters'
import { WhyUs } from '../components/shared/WhyUs'
import { ContactSales } from '../components/shared/ContactSales'
import { Footer } from '../layouts/Footer'

export const Home = () => {
    const contactSalesRef = useRef(null)
    const whyUsRef = useRef(null)

    const scrollToContactSales = () => {
        contactSalesRef.current.scrollIntoView({ behavior: "smooth" })
    }

    const scrollToWhyUs = () => {
        whyUsRef.current.scrollIntoView({ behavior: "smooth" })
    }
    return (
        <>
            <Navbar />
            <HeroSection scrollToContactSales={scrollToContactSales} scrollToWhyUs={scrollToWhyUs} />
            <Hero2 />
            <Figures />
            <Partners />
            <Supporters />
            <WhyUs whyUsRef={whyUsRef} />
            <ContactSales refe={contactSalesRef} />
            <Footer header={["Keep up with the latest", "news from Clinqo"]} />
        </>
    )
}
